import { h, JSX } from 'preact';
import ObservingComponent from '../../componentBases/observingComponent';
import EventInfoTile from '../../events/eventInfoTile';
import EventHotelConfigurationForm from '../../events/eventHotelConfigurationForm/eventHotelConfigurationForm';
import Button from '../../buttons/button';
import Alert from '../../alerts/alert';
import HotelConfigurationsTileProps from './hotelConfigurationsTileProps';

class HotelConfigurationsTile extends ObservingComponent<HotelConfigurationsTileProps> {

    public componentWillMount(): void {
        this.registerUpdateObserver(this.props.tile.observationProvider);
    }

    public render({ tile }: HotelConfigurationsTileProps): JSX.Element {

        return (
            <EventInfoTile
                color="dark-tan"
                tile={tile}
                icon="ti-hotel-configuration"
                editModeButtons={[
                    <Button
                        stopPropagation={true}
                        button={tile.exitEditModeButton}
                        className="cancel-button v-center"  />,
                    <Button
                        stopPropagation={true}
                        button={tile.saveButton}
                        className="update-button v-center" />
                ]}>

                {tile.isLoading ?
                    'Loading...'
                    :
                    (
                        <div>
                            <Alert
                                className="mt-1"
                                alert={tile.alert} />

                            <EventHotelConfigurationForm form={tile.eventHotelConfigurationForm} />
                        </div>
                    )
                }

            </EventInfoTile>
        );
    }
}

export default HotelConfigurationsTile;
